module.exports = __webpack_public_path__ + "img/Guneev_Headshot.29ae827b.jpg";